var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"persisFusionContainer",attrs:{"id":"main"}},[_c('iframe',{key:_vm.url,ref:"persisFusionFrame",attrs:{"id":"persisMain","data-name":"persis-fusion-frame","src":_vm.url},on:{"load":_vm.iframeLoaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }